<script setup lang="ts">
import { type TService } from "@/assets/js/types";
import { gsap } from "gsap";

type TProps = {
	service: TService;
	index?: string;
	isOpen?: boolean;
};
const props = withDefaults(defineProps<TProps>(), { isOpen: false });

function onEnter(el: Element, done: () => void) {
	// gsap.fromTo(
	// 	el,
	// 	{ opacity: 0, scale: 0.8, y: 40 },
	// 	{
	// 		opacity: 1,
	// 		scale: 1,
	// 		y: 0,
	// 		duration: 0.4,
	// 		ease: "power2.out",
	// 		onComplete: done,
	// 	},
	// );

	// const q = gsap.utils.selector(el);

	const tl = gsap.timeline({
		onComplete: done,
	});

	// sakrij ODMAH – nema blinka
	// tl.set(q(".animationSet"), {
	// 	opacity: 0,
	// 	scale: 0,
	// 	y: 50,
	// });

	tl.fromTo(
		el,
		{ opacity: 0, scale: 0.9, y: 40 }, // scale 0.9
		{
			opacity: 1,
			scale: 1,
			y: 0,
			duration: 0.4,
			ease: "power2.out",
		},
	);

	// tl.to(
	// 	q(".animationSet"),
	// 	{
	// 		opacity: 1,
	// 		scale: 1,
	// 		y: 0,
	// 		duration: 0.4,
	// 		stagger: 0.08,
	// 		ease: "power2.out",
	// 	},
	// 	"-=0.2",
	// );
}

function onLeave(el: Element, done: () => void) {
	gsap.to(el, {
		opacity: 0,
		scale: 0.8,
		y: 40,
		duration: 0.3,
		ease: "power2.in",
		onComplete: done,
	});
}

const indexRotatePosition = computed(() => {
	switch (props.index) {
		case "index-0":
			return -160;
		case "index-1":
			return -80;
		case "index-2":
			return 0;
		default:
			return -160;
	}
	// return -160;
});
function toBgLight(isOpen: boolean) {
	gsap.to(".bg-light", {
		rotation: isOpen
			? indexRotatePosition.value + 45
			: indexRotatePosition.value,
		duration: 1.2,
		// ease: "expo.out",
		ease: "power2.out",
		transformOrigin: "50% 50%",
	});
}
watch(
	() => props.isOpen,
	async (isOpen) => {
		// gsap.to(".bg-light", {
		// 	rotation: isOpen ? 45 : 0,
		// 	duration: 0.5,
		// 	ease: "power2.out",
		// });

		await nextTick();

		toBgLight(isOpen);
	},
);
const backgroundStyle = computed(() => {
	if (props.service.bgImg)
		return {
			backgroundImage: `url(${props.service.bgImg})`, // set bg image
			backgroundSize: "cover",
			backgroundPosition: "center",
		};
	return "";
});
const isMobile = ref(false);
function onResize() {
	if (window.innerWidth <= 768) {
		console.log("is mobile true ");
		isMobile.value = true;
	} else {
		console.log("is mobile false ");
		isMobile.value = false;
	}
}

onMounted(async () => {
	onResize();
	window.addEventListener("resize", onResize);
	await nextTick();
	console.log(indexRotatePosition.value, props.isOpen);
	if (props.isOpen) toBgLight(props.isOpen);
});
onUnmounted(() => {
	window.removeEventListener("resize", onResize);
});
</script>
<template>
	<div
		class="one-service"
		:class="[props.isOpen ? 'open' : '']"
		:style="backgroundStyle"
	>
		<div class="bg" :class="[props.index, { bg_open: isOpen }]">
			<div
				v-show="isOpen"
				class="bg-light"
				:style="{ transform: `rotate(${indexRotatePosition}deg)` }"
			></div>
			<Transition
				name="fade-slide"
				mode="out-in"
				@enter="onEnter"
				@leave="onLeave"
			>
				<div v-if="(isOpen && !isMobile) || isMobile" class="content-open">
					<h2 class="title animationSet">{{ service.title }}</h2>
					<div class="wrapp-txt">
						<div
							v-for="(value, index1) in service.text"
							:key="index1"
							class="txt animationSet"
						>
							{{ value }}
						</div>
					</div>

					<a
						v-if="service.link.startsWith('http')"
						:href="service.link"
						target="_blank"
						class="animationSet"
						>See more <img src="@/assets/images/arrow_insert.svg" alt="" />
					</a>
					<router-link v-else class="animationSet" :to="{ name: service.link }">
						See more <img src="@/assets/images/arrow_insert.svg" alt="" />
					</router-link>
				</div>

				<h2 v-else class="content-default">{{ service.title }}</h2>
			</Transition>
		</div>
	</div>
</template>
<style lang="scss" scoped>
// old
// .fade-slide-enter-active,
// .fade-slide-leave-active {
// 	transition:
// 		opacity 0.3s ease,
// 		transform 0.3s ease,
// 		width 0.3s ease;
// }

// if you don't want to use gsap, comment out @enter="onEnter" @leave="onLeave" and uncomment this
// .fade-slide-enter-from {
// 	opacity: 0;
// 	transform: translateY(0);
// }

// .fade-slide-leave-to {
// 	opacity: 0;
// 	transform: translateY(160px);
// }

// .fade-slide-enter-active,
// .fade-slide-leave-active {
// 	transition:
// 		opacity 0.3s ease,
// 		transform 0.3s ease,
// 		width 0.3s ease;
// }

// .fade-slide-enter-from {
// 	opacity: 0;
// 	transform: translateY(100px) scale(0);
// }

// .fade-slide-leave-to {
// 	opacity: 0;
// 	transform: translateY(100px) scale(0);
// }
.animationSet {
	will-change: transform, opacity;
}

.one-service {
	width: 25%;
	height: 100%;
	// display: flex;
	// justify-content: center;
	// align-items: center;
	font-family: Archivo, sans-serif;

	/* magic */
	transition:
		width 0.7s ease,
		background-color 0.3s ease;
	overflow: hidden;
	text-align: center;
	position: relative;
}
.one-service.open {
	width: 50%;
	// background-color: #4b8fba46;
	// background: #53aa6c;
	background: #53aa6c;
	background: linear-gradient(
		180deg,
		rgba(0, 0, 0, 0.6) 0%,
		rgba(0, 0, 0, 0.8) 100%
	);
}
.bg {
	width: 100%;
	height: 100%;
	// background-color: #000203af;
	display: flex;
	justify-content: center;
	align-items: center;
	background: #53aa6c;
	// background: linear-gradient(
	// 	180deg,
	// 	rgba(0, 0, 0, 0.6) 0%,
	// 	rgba(0, 0, 0, 0.8) 100%
	// );
	background: linear-gradient(
		180deg,
		rgba(0, 0, 0, 0.6) 0%,
		rgba(0, 0, 0, 0.93) 100%
	);
	transition:
		width 0.7s ease,
		background-color 0.1s ease;
	// new
	position: relative;
	// overflow: hidden;
	overflow: visible !important;
}
.bg.bg_open {
	background: #53aa6c;
	// background: linear-gradient(
	// 	180deg,
	// 	rgba(0, 0, 0, 0.42) 0%,
	// 	rgba(0, 0, 0, 0.56) 100%
	// );
	background: linear-gradient(
		180deg,
		rgba(0, 0, 0, 0.42) 0%,
		rgba(0, 0, 0, 0.669) 100%
	);
}
.bg-light {
	position: absolute;
	// inset: 0;

	background-image: url("@/assets/images/backgroundServices/light.png");
	background-position: center;
	background-repeat: no-repeat;
	transform: rotate(0deg);
	transition: none;
	pointer-events: none;
	background-size: auto;
	opacity: 0.8;
	// position: absolute;
	// top: 50%;
	// left: 50%;
	width: 140%;
	height: 140%;
	// transform: translate(-50%, -50%) rotate(0deg);
	// background-image: url("@/assets/images/backgroundServices/light.png");
	// background-repeat: no-repeat;
	// background-position: center;
	// background-size: contain;
	// pointer-events: none;
}

.content-open {
	margin: 0 20px;
	width: 400px;
	min-height: 500px;
	opacity: 1;
	gap: 32px;
	border-radius: 32px;
	padding: 32px;
	// background: #ffffff14;
	// background: linear-gradient(90deg, #ffffff14 0%, #c6cbc93a 100%);
	background: linear-gradient(90deg, #ffffff03 0%, #c6cbc91f 100%);
	backdrop-filter: blur(4.3px) !important;
	border: 1px solid rgba(255, 255, 255, 0.3);
	// border-image-source: linear-gradient(
	// 	120.04deg,
	// 	rgba(255, 255, 255, 0.3) 13.53%,
	// 	rgba(255, 255, 255, 0.2) 86.47%
	// );
	display: flex;
	flex-direction: column;
	text-align: left;

	.title {
		font-weight: 700;
		font-size: 32px;
		line-height: 110%;
		letter-spacing: 0%;
		margin-top: 0;
		margin-bottom: 32px;
	}
	.wrapp-txt {
		max-width: 300px;
		.txt {
			font-family: Poppins, sans-serif;
			font-weight: 400;
			font-size: 24px;
			line-height: 140%;
			letter-spacing: 0%;
			margin-bottom: 16px;
		}
		.txt:last-of-type {
			margin-bottom: 0;
		}
	}
	a {
		// margin-left: auto;
		margin-top: auto;
		// align-self:;
		background: linear-gradient(90deg, #6cc986 0%, #4bba9b 100%);
		width: fit-content;
		height: 42px;
		opacity: 1;
		border-radius: 38px;
		padding: 10px 12px;
		gap: 5px;
		display: flex;
		align-items: center;
		color: #fff;
	}
}
.content-default {
	margin: 0 20px;
	font-weight: 400;
	font-size: 28px;
	line-height: 100%;
	letter-spacing: 0%;
}
</style>
